export default function editForm() {
  return {
    components: [
      {
        type: 'textfield',
        key: 'label',
        label: 'Button Text',
        placeholder: 'Enter the button text',
        input: true
      },
      {
        type: 'select',
        key: 'buttonStyle',
        label: 'Button Style',
        data: {
          values: [
            { label: 'Primary', value: 'btn-primary' },
            { label: 'Secondary', value: 'btn-secondary' },
            { label: 'Success', value: 'btn-success' },
            { label: 'Danger', value: 'btn-danger' }
          ]
        },
        input: true,
        defaultValue: 'btn-primary'
      },
      {
        type: 'textarea',
        key: 'description',
        label: 'Description',
        placeholder: 'Optional description text',
        input: true
      }
    ]
  };
}
